const CacheAPI = function (enabledCache, cacheTime, excludeFromCache) {
  let store = {}
  let deepClone = function (item) {
    if (typeof item === 'object') {
      return JSON.parse(JSON.stringify(item))
    } else {
      return item
    }
  }

  return {
    isUrlExcluded: function (url) {
      return excludeFromCache[url]
    },
    isExpired: function (url) {
      let isExpiredData = true
      if (enabledCache && store[url]) {
        isExpiredData = (store[url].expired - new Date().getTime()) < 0
      }
      return isExpiredData
    },
    setCache: function (url, params, data) {
      if (!enabledCache) {
        return false
      }
      store[url] = {
        'params': deepClone(params),
        'data': deepClone(data),
        'expired': new Date().getTime() + cacheTime
      }
    },
    getCache: function (url) {
      return deepClone(store[url])
    }
  }
}

export default CacheAPI
